import React from 'react';
import { pr, r } from './helpers';
import LegacyPortalRedirect, { RiderLegacyRedirect } from '../../components/LegacyPortalRedirect';
import { RiderV2Page } from '../lazyPages';
import { isPathPortalEnvironment } from '../../utils/subdomain';

const RIDER = ['rider'];

/** Redirect legacy path-based rider URLs to rider-{slug} subdomain (v2 app). */
export function RiderLegacyPathRedirects() {
  if (isPathPortalEnvironment()) {
    return (
      <>
        {pr('/rider', RiderV2Page, RIDER)}
        {pr('/rider/*', RiderV2Page, RIDER)}
        {pr('/rider_v2', RiderV2Page, RIDER)}
        {pr('/rider_v2/*', RiderV2Page, RIDER)}
      </>
    );
  }

  return (
    <>
      {r('/rider', <LegacyPortalRedirect portal="rider" />)}
      {r('/rider/*', <LegacyPortalRedirect portal="rider" />)}
      {r('/rider_v2', <RiderLegacyRedirect />)}
      {r('/rider_v2/*', <RiderLegacyRedirect />)}
    </>
  );
}